import { render, staticRenderFns } from "./TaskStateEdit.vue?vue&type=template&id=825071ee&"
import script from "./TaskStateEdit.vue?vue&type=script&lang=js&"
export * from "./TaskStateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports